module.exports = __webpack_public_path__ + "img/fullscreen.09ddf294.svg";